import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
  codeGuide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));
